import { render, staticRenderFns } from "./StageSelectorCategory.vue?vue&type=template&id=67c97f10&scoped=true&"
import script from "./StageSelectorCategory.vue?vue&type=script&lang=js&"
export * from "./StageSelectorCategory.vue?vue&type=script&lang=js&"
import style0 from "./StageSelectorCategory.vue?vue&type=style&index=0&id=67c97f10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c97f10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VSubheader,VTab,VTabItem,VTabs,VTabsItems})
